module.exports = __webpack_public_path__ + "img/ship-opt.a172d32f.svg";